module.exports = __webpack_public_path__ + "static/img/07_xcn.2e2dd37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessPlatform/swiperImg/firstLine/07_xcn.png
// module id = E8aG
// module chunks = 0